import { withIconWrapper } from 'hocs/withIconWrapper';

import { ReactComponent } from './TrendUp.c.svg';

export const TrendUpIcon = withIconWrapper(ReactComponent);
